import { render, staticRenderFns } from "./DetalleSolicitud.vue?vue&type=template&id=1eb9dbfe&"
import script from "./DetalleSolicitud.vue?vue&type=script&lang=js&"
export * from "./DetalleSolicitud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPage,QToolbar,QToolbarTitle,QChip,QAvatar,QItem,QItemSection,QItemLabel,QCard,QList,QIcon,QCardActions,QBtn,QSeparator,QDialog,QCardSection,QForm,QSelect,QInput} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPage,QToolbar,QToolbarTitle,QChip,QAvatar,QItem,QItemSection,QItemLabel,QCard,QList,QIcon,QCardActions,QBtn,QSeparator,QDialog,QCardSection,QForm,QSelect,QInput})
